import React, { useState } from 'react';
import './Fish.css';

// Import images for fruits
import SharkImage from './images/Shark.png';
import Whale from './images/Whale.jpg';
import StarfishImage from './images/Starfish.jpg';
import SeaHorseImage from './images/SeaHorse.jpg';
import BlueTangImage from './images/BlueTang.jpg';
import SalmonImage from './images/Salmon.jpg';
import TunaImage from './images/Tuna.jpg';
import GoldfishImage from './images/Goldfish.jpg';
import AnglefishImage from './images/Anglefish.jpg';
import GuppyfishImage from './images/Guppyfish.jpg';

import ClownfishImage from './images/Clownfish.jpg';
import FlamingoImage from './images/Flamingo.jpg';
import PegionImage from './images/Pegion.jpg';
import DoveImage from './images/Dove.jpg';
import WeaverBirdImage from './images/WeaverBird.jpg';
import SwanImnage from './images/Swan.jpg';

const fruits = [
  { name: 'Shark', image: SharkImage },
  { name: 'Whale', image: Whale },
  { name: 'Star Fish', image: StarfishImage },
  { name: 'Sea Horse', image: SeaHorseImage },
  { name: 'Blue Tang Fish', image: BlueTangImage },
  { name: 'Salmon fish', image: SalmonImage },
  { name: 'Tuna Fish', image: TunaImage },
  { name: 'Gold Fish', image: GoldfishImage },
  { name: 'Angel Fish', image: AnglefishImage },
  { name: 'Guppy Fish', image: GuppyfishImage },

  { name: 'Clown Fish', image: ClownfishImage },
 
];

const Fish = () => {
  const [selectedFruit, setSelectedFruit] = useState(null);
  const [quizFruit, setQuizFruit] = useState(null);
  const [quizAnswer, setQuizAnswer] = useState('');
  const [quizResult, setQuizResult] = useState('');

  const speakFruit = (fruitName) => {
    const utterance = new SpeechSynthesisUtterance(fruitName);
    window.speechSynthesis.speak(utterance);
  };

  const handleFruitClick = (fruit) => {
    setSelectedFruit(fruit);
    speakFruit(fruit.name);
  };

  const startQuiz = () => {
    const randomFruit = fruits[Math.floor(Math.random() * fruits.length)];
    setQuizFruit(randomFruit);
    setQuizAnswer('');
    setQuizResult('');
  };

  const submitQuiz = () => {
    if (quizAnswer.toLowerCase() === quizFruit.name.toLowerCase()) {
      setQuizResult('Correct!');
    } else {
      setQuizResult(`Wrong! The correct Fish was ${quizFruit.name}`);
    }
  };

  const clearQuiz = () => {
    setQuizFruit(null);
    setQuizAnswer('');
    setQuizResult('');
  };

  const nextQuiz = () => {
    startQuiz();
  };

  return (
    <div className="AppFruits">
      <h1>Fish</h1>
      <div className="fruits">
        {fruits.map((fruit) => (
          <div
            key={fruit.name}
            className="fruit-box"
            onClick={() => handleFruitClick(fruit)}
          >
            <img src={fruit.image} alt={fruit.name} className="fruit-image" />
            <p>{fruit.name}</p>
          </div>
        ))}
      </div>
      {selectedFruit && <div className="selected-fruit">You selected: {selectedFruit.name}</div>}
      <div className="quiz-section">
        <h2>Quiz Mode</h2>
        {quizFruit ? (
          <div>
            <p>Which Fish is this?</p>
            <img src={quizFruit.image} alt="Quiz Fish" className="quiz-image" />
            <input
              type="text"
              value={quizAnswer}
              onChange={(e) => setQuizAnswer(e.target.value)}
              placeholder="Enter Fish name"
            />
            <button onClick={submitQuiz}>Submit</button>
            <button onClick={nextQuiz}>Next Fish</button>
            <button onClick={clearQuiz}>Clear</button>
            {quizResult && <p>{quizResult}</p>}
          </div>
        ) : (
          <button onClick={startQuiz}>Start Quiz</button>
        )}
      </div>
    </div>
  );
};

export default Fish;



